import { Container, StyledLoadingPlaceholder, Tabs } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledTabs = styled(Tabs)`
  margin-top: 3rem;
  width: 100%;
  & > div:first-of-type {
    @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
      text-align: center;
    }
  }
`;

export const StyledProfilePageContainer = styled(Container)`
  display: flex;
`;

export const StyledTabIconAndText = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

export const StyledTabPaper = styled.div<{ withoutBg?: boolean; withoutMargin?: boolean }>`
  padding: ${({ withoutBg }) => (withoutBg ? '0' : '3.2rem 1.8rem')};
  width: 100%;
  background: ${({ theme, withoutBg }) => (withoutBg ? '' : theme.colors.background.light)};
  box-shadow: ${({ theme, withoutBg }) => (withoutBg ? '' : theme.boxShadow.light)};
  margin-top: ${({ withoutMargin }) => (withoutMargin ? '0' : '2.4rem')};
  margin-bottom: ${({ withoutMargin }) => (withoutMargin ? '0' : '6rem')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2.4rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: ${({ withoutBg }) => (withoutBg ? '0' : '3.2rem')};
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    padding: ${({ withoutBg }) => (withoutBg ? '0' : '4.6rem')};
  }
`;

export const StyledNoItemsText = styled.div`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
`;

export const StyledLoadingPagination = styled.div`
  display: grid;
  place-items: center;
  gap: 1.9rem;
`;

export const StyledLoading = styled.div<{ width?: string; height?: string }>`
  ${StyledLoadingPlaceholder};
  width: ${({ width }) => width ?? '100%'};
  height: ${({ height }) => height ?? '15.4rem'};
`;
